export enum ConsentId {
  SCREENING_CONSENT = 'SCREENING_CONSENT',
  HEALTH_CALL_JOURNAL = 'HEALTH_CALL_JOURNAL',
  SCREENING_SUMMARY_JOURNAL = 'SCREENING_SUMMARY_JOURNAL',
}

export type JournalConsentId = ConsentId.HEALTH_CALL_JOURNAL | ConsentId.SCREENING_SUMMARY_JOURNAL

// Bump a version when the consent text changes; the API holds the matching number and rejects anything else.
export const CONSENT_VERSIONS: Record<JournalConsentId, number> = {
  [ConsentId.HEALTH_CALL_JOURNAL]: 1,
  [ConsentId.SCREENING_SUMMARY_JOURNAL]: 1,
}

export type Consent = {
  id: string
  consentId: ConsentId
  userId: string
  version: number | null
}

export const getConsentVersion = (consentId: ConsentId): number | undefined =>
  Object.entries(CONSENT_VERSIONS).find(([id]) => id === consentId)?.[1]
